import React, { useState, useRef, useEffect } from 'react';
import Header from '../../../common/components/Header/Header';
import Sidebar from '../../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../../data/SiteConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/pro-light-svg-icons';
import styles from './PLStatementTable/PLStatement.module.css';
import * as _ from 'lodash';
import moment from 'moment';
import arrow_down from '../../../images/icons/angle_arrow.svg';
import CommonYearPicker from '../../../common/components/CommonYearPicker/CommonYearPicker';
import { getPLReport, getPLIncomeReport } from '../../../common/constants/api';
import PopUp from '../../../common/components/PopUp/PopUp';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import { numberFormat } from '../../../common/constants/NumberFormat';
let expensesRows = ['Salary', 'Incentives', 'Compensation (Salary+incentive)'];
const PLStatement = () => {
  const {
    tableStyle,
    incomeTableStyle,
    arrow_style,
    fixPosition,
    fixPositionLeft,
    fixPositionLeftForHeader,
    fixPositionRightForImage,
    incomeInvisible,
    incomeVisible,
    img_180deg,
    kpiInvisible,
    kpiVisible
  } = styles;
  const incomeRef = useRef(null);
  const expansesRef = useRef(null);
  const [popType, setPopType] = useState('loading');
  const [popUpText, setPopUpText] = useState('Loading..');
  const [showIncome, setShowIncome] = useState(true);
  const [showKPI, setShowKPI] = useState(true);
  const [loading, setLoading] = useState(true);
  const [kpiLeadData, setKpiLeadData] = useState();
  const [kpiLoginsData, setKpiLoginsData] = useState();
  const [kpiSanctionData, setKpiSanctionData] = useState();
  const [kpiDisbursementData, setKpiDisbursementData] = useState();
  const [kpiBPsData, setKpiBPsData] = useState();
  const [kpiTransactingData, setKpiTransactingData] = useState();
  const [kpiHeadcountData, setKpiHeadcountData] = useState();
  const [showExpanses, setShowExpanses] = useState(false);
  const [incomeLoginsData, setIncomeLoginsData] = useState();
  const [incomeSanctionData, setIncomeSanctionData] = useState();
  const [incomeDisbursementData, setIncomeDisbursementData] = useState();
  const [years, setYears] = useState({
    value: '',
    label: 'Choose Years'
  });
  const getPLReportFunc = () => {
    setLoading(true);

    getPLReport(years?.value ? years?.value : moment().format('YYYY'))
      .then(res => {
        if (res.error) throw new Error(res);
        setLoading(false);
        setKpiLeadData(res?.leads);
        setKpiLoginsData(res?.logins);
        setKpiSanctionData(res?.sanction);
        setKpiDisbursementData(res?.disbursement);
        setKpiBPsData(res?.bps);
        setKpiTransactingData(res?.transactingBps);
        setKpiHeadcountData(res?.headCount);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getPLReportFunc();
  }, [years?.value]);

  const getPLIncomeReportFunc = () => {
    setLoading(true);

    getPLIncomeReport(years?.value ? years?.value : moment().format('YYYY'))
      .then(res => {
        if (res.error) throw new Error(res);
        setLoading(false);
        setIncomeLoginsData(res?.logins);
        setIncomeSanctionData(res?.sanction);
        setIncomeDisbursementData(res?.disbursement);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getPLIncomeReportFunc();
  }, [years?.value]);

  return (
    <React.Fragment>
      <Helmet title={`Dashboard RM | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full  font-roboto text-sm font-normal m-0 p-0">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />

          <div className="widhtMd max-screen flex-1 w-full ">
            <div className="flex">
              <div className="flex items-center  flex-col xl:flex-row w-full">
                <div className="w-full text-black-400 text-md ml-4 font-bold mt-4 relative">
                  <span className="mr-1 cursor-pointer">Reports</span>
                  <FontAwesomeIcon icon={faAngleDoubleRight} className="mr-1" />
                  <span className="text-green-800">P/L Statement</span>
                </div>
              </div>
              <Header />
            </div>
            <div className="w-full">
              <div className="px-5 py-2">
                <CommonYearPicker
                  years={years}
                  setYears={setYears}
                  selectBaseYear={true}
                  baseYear={2020}
                  addYears={0}
                />
              </div>
              <div
                className={` w-full px-4 pb-2 mt-2  relative overflow-auto`}
                style={{
                  maxHeight: '80vh'
                }}
              >
                <div
                  className={`w-full  m-auto `}
                  style={{
                    borderRadius: 'inherit'
                  }}
                >
                  <table className={`w-full pb-6 `}>
                    <thead>
                      <tr>
                        <td colSpan="13" style={{ paddingBottom: '0px' }}>
                          <div
                            className="w-full flex  items-center pt-3 cursor-pointer"
                            style={{ backgroundColor: '#E7EEF8' }}
                            onClick={() => setShowKPI(!showKPI)}
                          >
                            <p
                              className={`table  font-medium text-lg font-roboto text-black-500 ${fixPositionLeftForHeader}`}
                            >
                              KPI
                            </p>
                            <div className="w-full text-center">
                              <img
                                src={arrow_down}
                                className={`${arrow_style} h-6  block right-0 transform mt-4 text-white w-4  ml-auto ${fixPositionRightForImage} ${!showKPI &&
                                  img_180deg}`}
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    </thead>

                    <thead className="">
                      <tr className="">
                        <th
                          className={`w-2/11 px-4 mx-2 py-2 text-left ${fixPosition} ${fixPositionLeft}`}
                          style={{ zIndex: '9' }}
                        >
                          Particulars
                        </th>
                        <th
                          className={`w-1/11 px-4 py-2 text-right ${fixPosition}`}
                        >
                          Jan
                        </th>
                        <th
                          className={`w-1/11 px-4 py-2 text-right ${fixPosition}`}
                        >
                          Feb
                        </th>
                        <th
                          className={`w-1/11 px-4 py-2 text-right ${fixPosition}`}
                        >
                          Mar
                        </th>
                        <th
                          className={`w-1/11 px-4 py-2 text-right ${fixPosition}`}
                        >
                          Apr
                        </th>
                        <th
                          className={`w-1/11 px-4 py-2 text-right ${fixPosition}`}
                        >
                          May
                        </th>
                        <th
                          className={`w-1/11 px-4 py-2 text-right ${fixPosition}`}
                        >
                          Jun
                        </th>
                        <th
                          className={`w-1/11 px-4 py-2 text-right ${fixPosition}`}
                        >
                          Jul
                        </th>
                        <th
                          className={`w-1/11 px-4 py-2 text-right ${fixPosition}`}
                        >
                          Aug
                        </th>
                        <th
                          className={`w-1/11 px-4 py-2 text-right ${fixPosition}`}
                        >
                          Sep
                        </th>
                        <th
                          className={`w-1/11 px-4 py-2 text-right ${fixPosition}`}
                        >
                          Oct
                        </th>
                        <th
                          className={`w-1/11 px-4 py-2 text-right ${fixPosition}`}
                        >
                          Nov
                        </th>
                        <th
                          className={`w-1/11 px-4 py-2 text-right ${fixPosition}`}
                        >
                          Dec
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      className={`${tableStyle} ${
                        showKPI ? kpiVisible : kpiInvisible
                      }`}
                    >
                      {kpiLeadData && (
                        <React.Fragment>
                          <tr className=" ">
                            <td className={`px-4 py-4 ${fixPositionLeft}`}>
                              Leads
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLeadData?.Jan || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLeadData?.Feb || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLeadData?.Mar || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLeadData?.Apr || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLeadData?.May || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLeadData?.Jun || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLeadData?.Jul || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLeadData?.Aug || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLeadData?.Sep || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLeadData?.Oct || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLeadData?.Nov || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLeadData?.Dec || 0}
                            </td>
                          </tr>
                          <tr className=" ">
                            <td className={`px-4 py-4 ${fixPositionLeft}`}>
                              Logins
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLoginsData?.Jan || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLoginsData?.Feb || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLoginsData?.Mar || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLoginsData?.Apr || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLoginsData?.May || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLoginsData?.Jun || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLoginsData?.Jul || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLoginsData?.Aug || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLoginsData?.Sep || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLoginsData?.Oct || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLoginsData?.Nov || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiLoginsData?.Dec || 0}
                            </td>
                          </tr>
                          <tr className=" ">
                            <td className={`px-4 py-4 ${fixPositionLeft}`}>
                              Sanction
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiSanctionData?.Jan || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiSanctionData?.Feb || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiSanctionData?.Mar || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiSanctionData?.Apr || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiSanctionData?.May || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiSanctionData?.Jun || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiSanctionData?.Jul || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiSanctionData?.Aug || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiSanctionData?.Sep || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiSanctionData?.Oct || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiSanctionData?.Nov || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiSanctionData?.Dec || 0}
                            </td>
                          </tr>
                          <tr className=" ">
                            <td className={`px-4 py-4 ${fixPositionLeft}`}>
                              Disbursement
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiDisbursementData?.Jan || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiDisbursementData?.Feb || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiDisbursementData?.Mar || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiDisbursementData?.Apr || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiDisbursementData?.May || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiDisbursementData?.Jun || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiDisbursementData?.Jul || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiDisbursementData?.Aug || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiDisbursementData?.Sep || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiDisbursementData?.Oct || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiDisbursementData?.Nov || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiDisbursementData?.Dec || 0}
                            </td>
                          </tr>
                          <tr className=" ">
                            <td className={`px-4 py-4 ${fixPositionLeft}`}>
                              BP’s
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiBPsData?.Jan || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiBPsData?.Feb || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiBPsData?.Mar || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiBPsData?.Apr || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiBPsData?.May || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiBPsData?.Jun || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiBPsData?.Jul || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiBPsData?.Aug || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiBPsData?.Sep || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiBPsData?.Oct || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiBPsData?.Nov || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiBPsData?.Dec || 0}
                            </td>
                          </tr>
                          <tr className=" ">
                            <td className={`px-4 py-4 ${fixPositionLeft}`}>
                              Transacting BP’s
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiTransactingData?.Jan || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiTransactingData?.Feb || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiTransactingData?.Mar || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiTransactingData?.Apr || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiTransactingData?.May || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiTransactingData?.Jun || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiTransactingData?.Jul || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiTransactingData?.Aug || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiTransactingData?.Sep || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiTransactingData?.Oct || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiTransactingData?.Nov || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiTransactingData?.Dec || 0}
                            </td>
                          </tr>
                          <tr className=" ">
                            <td className={`px-4 py-4 ${fixPositionLeft}`}>
                              Headcount
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiHeadcountData?.Jan || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiHeadcountData?.Feb || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiHeadcountData?.Mar || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiHeadcountData?.Apr || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiHeadcountData?.May || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiHeadcountData?.Jun || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiHeadcountData?.Jul || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiHeadcountData?.Aug || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiHeadcountData?.Sep || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiHeadcountData?.Oct || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiHeadcountData?.Nov || 0}
                            </td>
                            <td className="px-4 py-4 text-right">
                              {kpiHeadcountData?.Dec || 0}
                            </td>
                          </tr>
                        </React.Fragment>
                      )}
                    </tbody>
                    <tbody
                      className={`${incomeTableStyle} ${
                        showIncome ? incomeVisible : incomeInvisible
                      }`}
                    >
                      <tr>
                        <td colSpan="13">
                          <div
                            className={`flex bg-white cursor-pointer  mx-auto py-4 items-center`}
                            onClick={e => {
                              setShowIncome(!showIncome);
                              setShowExpanses(false);
                            }}
                          >
                            <p
                              className={`table px-5 py-4 font-medium text-lg font-roboto text-black-500 pl-4 ${fixPositionLeftForHeader}`}
                            >
                              Income
                            </p>
                            <div className="w-full text-center">
                              <img
                                src={arrow_down}
                                className={`${arrow_style} h-6  block right-0 transform mt-4 text-white w-4  ml-auto ${fixPositionRightForImage} ${!showIncome &&
                                  img_180deg}`}
                              />
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr className={` `}>
                        <td
                          className={`px-4 py-4 w-2/11  mx-2 ${fixPositionLeft}`}
                        >
                          Logins
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeLoginsData?.Jan || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377; &nbsp;
                          {numberFormat(incomeLoginsData?.Feb || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377; &nbsp;
                          {numberFormat(incomeLoginsData?.Mar || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeLoginsData?.Apr || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeLoginsData?.May || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeLoginsData?.Jun || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeLoginsData?.Jul || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeLoginsData?.Aug || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeLoginsData?.Sep || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeLoginsData?.Oct || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeLoginsData?.Nov || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeLoginsData?.Dec || 0)}
                        </td>
                      </tr>
                      <tr className=" ">
                        <td className={`px-4 py-4 w-2/11 ${fixPositionLeft}`}>
                          Sanction
                        </td>
                        <td className="px-4 py-4 text-right">
                          &#8377;&nbsp;
                          {numberFormat(incomeSanctionData?.Jan || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeSanctionData?.Feb || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeSanctionData?.Mar || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeSanctionData?.Apr || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeSanctionData?.May || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeSanctionData?.Jun || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeSanctionData?.Jul || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeSanctionData?.Aug || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeSanctionData?.Sep || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeSanctionData?.Oct || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeSanctionData?.Nov || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeSanctionData?.Dec || 0)}
                        </td>
                      </tr>
                      <tr className=" ">
                        <td className={`px-4 py-4 w-2/11 ${fixPositionLeft}`}>
                          Disbursement
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeDisbursementData?.Jan || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeDisbursementData?.Feb || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeDisbursementData?.Mar || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeDisbursementData?.Apr || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeDisbursementData?.May || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeDisbursementData?.Jun || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeDisbursementData?.Jul || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeDisbursementData?.Aug || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeDisbursementData?.Sep || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeDisbursementData?.Oct || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeDisbursementData?.Nov || 0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(incomeDisbursementData?.Dec || 0)}
                        </td>
                      </tr>
                      <tr className="  ">
                        <td className={`px-4 py-4 w-2/11 ${fixPositionLeft}`}>
                          Gross Retention
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;{numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                      </tr>
                      <tr className=" ">
                        <td className={`px-4 py-4 w-2/11 ${fixPositionLeft}`}>
                          Net Retention
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;{numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                      </tr>

                      <tr className=" ">
                        <td className={`px-4 py-4 w-2/11 ${fixPositionLeft}`}>
                          Amount Received
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;{numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                        <td className="px-4 py-4 text-right w-1/11">
                          &#8377;&nbsp;
                          {numberFormat(0)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                className={` w-full px-4 pb-6 mt-1 bg-grey-1004 `}
                ref={incomeRef}
              >
                {showIncome && (
                  <div
                    className={`w-full relative m-auto `}
                    style={{
                      position: 'relative',
                      borderRadius: 'inherit',
                      overflowX: 'auto',
                      overflowY: 'hidden'
                    }}
                  >
                    <table className={`w-full pb-6 ${incomeTableStyle}`}>
                      <tbody className=""></tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <PopUp
        setShow={setLoading}
        show={loading}
        type={popType}
        text={popUpText}
        dontClose
      />
    </React.Fragment>
  );
};
export default withErrorHandler(PLStatement);
